module.exports = __webpack_public_path__ + "assets/img/16.370d39b9.png";